import clsx from "clsx";
import React, { forwardRef, ReactNode, useContext } from "react";

import { CommonColors } from "../../../../types/colors";
import { TabsContext } from "../../tabs-context";
import { colorScheme } from "./styles";

export interface SquaredTabHeaderItemProps {
  id: string;
  className?: string;
  color: CommonColors;
  header: ReactNode;
  subHeader?: ReactNode;
}

export const SquaredTabHeaderItem = forwardRef<HTMLDivElement, SquaredTabHeaderItemProps>(
  ({ id, className, header, subHeader, color }, ref) => {
    const { activeTab, setActiveTab } = useContext(TabsContext);
    const isActive = activeTab === id;

    const { inactiveText, activeText } = colorScheme[color];

    return (
      <div
        ref={ref}
        onClick={() => setActiveTab(id)}
        className={clsx(
          "relative text-lg pt-4 pb-3 px-10 cursor-pointer h-full z-10",
          "select-none border-0 transition-all duration-300",
          isActive ? activeText : inactiveText,
          className
        )}
      >
        <h3 className="font-medium text-xl 2xl:text-2xl 3xl:text-3xl pb-1 whitespace-nowrap min-w-[5ch]">
          {header}
        </h3>
        {subHeader && (
          <div
            style={{
              minWidth: `${Math.min(
                20,
                typeof subHeader === "string" ? subHeader.length : Infinity
              )}ch`,
            }}
            className="font-light text-sm 2xl:text-base"
          >
            {subHeader}
          </div>
        )}
      </div>
    );
  }
);
